import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'
import { SOCIAL_ANALYTICS_PATH } from './constants/social-analytics.constants'

const SocialAnalyticsPage = lazyWithRetry(() => import('./pages/SocialAnalyticsPage'))

const routes: AppRoute[] = [
  {
    path: SOCIAL_ANALYTICS_PATH,
    children: [
      {
        index: true,
        element: SocialAnalyticsPage,
        meta: {
          title: 'sidebarNav.socialAnalytics',
          // The API serves this to viewers; the dashboard writes nothing.
          require: { minRole: ROLE.VIEWER },
        },
      },
    ],
  },
]

export default routes
